import React from 'react';
import { KitMasajista } from './pages/KitMasajista';
export function App() {
  return <KitMasajista data-id="element-0" />;
}